import PolygonUploadUtils from "./PolygonUploadUtils";

class MapPolygonUtils {
  static parseTerminalGeoJSON(marker) {
    if (!marker) return null;

    const raw =
      marker.terminalGeoJSON ??
      marker.terminal_geo_json ??
      marker.terminal_geojson ??
      marker.terminalGeoJson ??
      marker.polygon;
    if (!raw) return null;

    let geojson = raw;
    if (typeof raw === "string") {
      try {
        geojson = JSON.parse(raw);
      } catch {
        return null;
      }
    }

    if (geojson.type === "Feature") {
      geojson = geojson.geometry;
    } else if (geojson.type === "FeatureCollection" && geojson.features?.[0]?.geometry) {
      geojson = geojson.features[0].geometry;
    }

    if (geojson.type === "Polygon") {
      return PolygonUploadUtils.convertPolygonToMultiPolygon(geojson);
    }

    if (geojson.type === "MultiPolygon" && geojson.coordinates) {
      return geojson;
    }

    return null;
  }

  static getPolygonCenter(polygon) {
    let latSum = 0;
    let lngSum = 0;
    let count = 0;

    polygon.forEach((ring) => {
      ring.forEach(([lng, lat]) => {
        latSum += lat;
        lngSum += lng;
        count++;
      });
    });

    if (count === 0) return null;

    return {
      lat: latSum / count,
      lng: lngSum / count,
    };
  }

  static extendBoundsWithMarker(bounds, marker) {
    const polygonGeoJson = this.parseTerminalGeoJSON(marker);

    if (polygonGeoJson?.coordinates) {
      polygonGeoJson.coordinates.forEach((polygon) => {
        polygon.forEach((ring) => {
          ring.forEach(([lng, lat]) => {
            bounds.extend([lat, lng]);
          });
        });
      });
      return;
    }

    if (marker.latitude && marker.longitude) {
      bounds.extend([marker.latitude, marker.longitude]);
    }
  }
}

export default MapPolygonUtils;
